/* eslint-disable jsx-a11y/media-has-caption */
import React, { Component } from 'react';
import { getSignedUrl } from 'legacy/src/shared/clients/apiClient';
import './audio.scss';

// Since this is a special embeded item, there is no passed in "print" context or printMode prop.
// Because of that, we use a print media query and the :after css property to set a message. This
// means that all audio files will have the same message when printed. Something to be mindful of.

class Player extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      src: null,
    };
  }

  componentDidMount() {
    const {
      item: {
        content: { src: url },
      },
    } = this.props;
    if (this.state.src === null) {
      this._loadData(url);
    }
  }

  componentDidUpdate() {
    const { src: prevUrl } = this.state;
    const {
      item: {
        content: { src: nextUrl },
      },
    } = this.props;
    if (prevUrl !== nextUrl) {
      this._loadData(nextUrl);
    }
  }

  _loadData(url) {
    if (!this._loadData.cache) this._loadData.cache = {};

    if (!this._loadData.cache[url]) {
      this.setState({
        loading: true,
      });
      this._loadData.cache[url] = getSignedUrl(url).then((result) => {
        this.setState({
          src: result,
          loading: false,
        });
        delete this._loadData.cache[url];
      });
    }
  }

  render() {
    const { signedUrl = false } = this.props.item.content;
    const { loading, src } = this.state;
    return (
      <span data-am-type="media/audio" className="audio-player">
        {loading ? null : <audio src={signedUrl || src} controls />}
      </span>
    );
  }
}

Player.displayName = 'Audio';

const status = (item, state = {}) => ({
  viewed: state.viewed ? 1 : 0,
});

export default { Player, status };
